import { makeStyles, Paper } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface IProps {
    icon?: JSX.Element;
}

const useStyles = makeStyles({
    root: {
        background: '#E8EAF4',
        display: 'flex',
        justifyContent: 'center',
        color: '#8D98B7',
        padding: '1rem',
        alignItems: 'center',
    },
    content: {
        textAlign: 'center',
    },
});

export function PermissionsUI({ icon }: IProps) {
    const { t } = useTranslation();
    const { root, content } = useStyles();
    return (
        <Paper className={root}>
            <div className={content}>
                {icon && icon}
                <p>{t('permissions.noPermission')}</p>
            </div>
        </Paper>
    );
}
